import clsx from "clsx";
import { FC } from "react";
import CloseIcon from "@ht/shared/fonts/deos-pis/close";

const SlideModal: FC<{
    title: string;
    visible: boolean;
    onClose: () => void;
    className?: string;
    showBackDrop?: boolean;
    direction?: "LEFT_TO_RIGNT" | "RIGHT_TO_LEFT";
}> = ({
    visible,
    onClose,
    className,
    children,
    title,
    showBackDrop = true,
    direction = "RIGHT_TO_LEFT",
}) => {
    return (
        <>
            <div
                className={clsx(
                    {
                        "transition-all duration-500 my-2 ml-2 fixed z-30 bg-white":
                            true,
                        "-right-[3000px]":
                            !visible && direction == "RIGHT_TO_LEFT",
                        "right-2": visible && direction == "RIGHT_TO_LEFT",
                        "-left-[3000px]":
                            !visible && direction == "LEFT_TO_RIGNT",
                        "left-0": visible && direction == "LEFT_TO_RIGNT",
                        "rounded-lg p-4 ": true,
                        "shadow border-t border-t-gray-100": !showBackDrop,
                    },
                    className
                )}
            >
                <div className="flex justify-between pb-4 border-b border-gray-100 mb-4">
                    <div className="truncate mr-1 text-md text-gray-700 font-bold ">
                        {title}
                    </div>
                    <CloseIcon
                        onClick={onClose}
                        className="hover:cursor-pointer text-gray-400 w-4 "
                    />
                </div>
                {children}
            </div>
            {showBackDrop && (
                <div className="static">
                    {
                        <div
                            className={clsx({
                                "transition-opacity duration-1000 bg-gray-500 w-full z-20 h-full absolute -top-0 left-0 ":
                                    true,
                                "opacity-0 invisible": !visible,
                                "opacity-50 visible": visible,
                            })}
                        ></div>
                    }
                </div>
            )}
        </>
    );
};

export default SlideModal;
